var webScriptMain = (function ($) {

  /**
   * Initialize
   *
   */
  var init = function () {

    /**
     * メインビジュアルのスライドショー
     * @top
     */
    if ($('.top-slides').length) {
      var slideTimer = 0;

      // スライドショーの設定
      function initSlideshow() {
        var imageIndex = 0;
        var autoSlideTimer = 0;
        var autoSlideDuration = 6000;
        var isAutoSlide;

        var $slider = $('.top-slides');
        var slides = $slider.find('.slide-item');
        var slide_length = slides.length;
        // var slide_navs = $('.slide-nav li');

        if (slide_length > 1) {
          // // サムネイル押下時
          // slide_navs.find('a').on('click',function(e){
          //   e.preventDefault();

          //   clearAutoSlideTimer();

          //   var index = slide_navs.index($(this).parent());
          //   switchMainImage(index, false);

          //   var current_point = slide_navs.filter('.selected');
          //   var current_index = slide_navs.index(current_point);
          //   imageIndex = current_index;
          // });

          // 自動スライドの操作関連
          var setAutoSlideTimer = function() {
            autoSlideTimer = setTimeout(function(){
              autoSlideImage();
            }, autoSlideDuration);
          }
          var clearAutoSlideTimer = function() {
            clearTimeout(autoSlideTimer);
          }
          var autoSlideImage = function(){
            var index = imageIndex;
            if (index == slide_length - 1) index = 0;
            else index++;

            switchMainImage(index, true);

            imageIndex = index;
          }
          // 自動スライドの切り替わり
          var switchMainImage = function(i, flag) {
            if (flag) {
              slides.filter('.selected').removeClass('selected').css({'z-index':'1'});
              slides.eq(i).addClass('selected').css({'z-index':'2'});

              // $('.slide-nav li').filter('.selected').removeClass('selected');
              // $('.slide-nav li').eq(i).addClass('selected');

              setAutoSlideTimer();
            }
            else {
              // $slider.find('li.selected').removeClass('selected').css({'z-index':'1'});
              // $slider.find('li').eq(i + slide_length).addClass('selected').css({'z-index':'2'});

              // $('.slide-nav li').filter('.selected').removeClass('selected');
              // $('.slide-nav li').eq(i).addClass('selected');
            }
          }

          $('.arrow.prev').on('click', function(e) {
            e.preventDefault();
            clearAutoSlideTimer();

            var prevIndex = imageIndex - 1;
            if (prevIndex < 0) prevIndex = slide_length - 1;

            switchMainImage(prevIndex, true);
            imageIndex = prevIndex;
          });

          $('.arrow.next').on('click', function(e) {
            e.preventDefault();
            clearAutoSlideTimer();

            var nextIndex = imageIndex + 1;
            if (nextIndex >= slide_length) nextIndex = 0;

            switchMainImage(nextIndex, true);
            imageIndex = nextIndex;
          });

          // 最初のタイマーセット
          setAutoSlideTimer();
        }
        else {
          var $img = $(slides[0]);
          $img.css({opacity:1, 'z-index':2});
        }
      }
      // スライドショーの開始
      initSlideshow();
    }


    /**
     * ページ内リンクの処理
     * @COMMON
     */
    $('a[href^="#"]').on('click', function(e) {
      e.preventDefault();
      if ($(this).hasClass('unscrollable')) return false;

      var a = $(this).attr('href');
      scrollTo(a);
    });


    /**
     * スクロールイベント発生時
     * @COMMON
     */
    $(window).scroll(function() {
      var st = $(window).scrollTop(),
          ww = document.documentElement.clientWidth,
          wh = document.documentElement.clientHeight;

      // スクロール処理
      
    });
  }


  /**
   * @Utilities
   *
   */
  var scrollTo = function (id) {
    var pos = 0,
      speed = 950,
      ww = document.documentElement.clientWidth,
      diff = 0;//(ww > 600) ? 72 : 48;

    var pos = (id != '#top') ? $(id).offset().top - diff : 0;

    $('html, body').dequeue();
    $('html, body').animate({ scrollTop: pos }, speed, 'easeInOutQuart');
  };


  return {
    init: init
  };

}(jQuery));


/**
 * Initialize
 *
 */
jQuery(function () {

  webScriptMain.init();

});


/**
 * Easing Plugins
 *
 */
$.extend($.easing,
{
  easeInOutQuart: function (x, t, b, c, d) {
    if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
    return -c/2 * ((t-=2)*t*t*t - 2) + b;
  },
});
